// extracted by mini-css-extract-plugin
export default {"container":"dPRjxN","innerContainer":"Of0AtV","title":"fRvRFs","body":"_0N0AO4","list":"z4n7V0","button":"fF8H3H","isMuted":"oPChh1"};